import React, { useState, useEffect } from "react";
import "./index.css";
import "./App.css";

// Main FindTournakis Game Component
export default function FindTournakisGame() {
  // State to manage game progress
  const [currentLandscape, setCurrentLandscape] = useState(0);
  const [isFound, setIsFound] = useState(false);
  const [score, setScore] = useState(0);
  const [tournakisPosition, setTournakisPosition] = useState({ x: 50, y: 50 });
  const [gameStarted, setGameStarted] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [debugMode, setDebugMode] = useState(true);

  // Update these paths to match your actual image filenames in the public folder
  const landscapes = [
    "/landscape00.jpeg",
    "/landscape0.jpg",
    "/landscape1.jpg",
    "/landscape2.jpg",
    "/landscape3.jpg",
    "/landscape4.jpg",
    "/landscape5.jpg",
    "/landscape6.jpg",
    "/landscape7.jpg",
    "/landscape8.jpg",
    "/landscape9.jpg",
    "/landscape10.jpg",
    "/landscape11.jpg",
    "/landscape12.jpg",
    "/landscape13.jpg",
    "/landscape14.jpg",
    "/landscape15.jpg",
    "/landscape16.jpg",
    "/landscape17.jpg",
    "/landscape18.jpg",
    "/landscape19.jpg",
    "/landscape20.jpg",
    "/landscape21.jpg",
    "/landscape22.jpg",
    "/aphi.jpeg",
    "/aphi.jpg",
    "/kozi.jpg",
    "/marinos1.jpg",
    // Add more landscapes as needed
  ];

  // Path to your Tournakis image in the public folder
  let tournakisImagePath = "/tournak.png";

  if (landscapes[currentLandscape] === "/marinos1.jpg") {
    tournakisImagePath = "/marinos.png";
  } else if (landscapes[currentLandscape] === "/aphi.jpeg") {
    tournakisImagePath = "/aphi.png";
  } else if (landscapes[currentLandscape] === "/aphi.jpg") {
    tournakisImagePath = "/aphi.png";
  } else if (landscapes[currentLandscape] === "/kozi.jpg") {
    tournakisImagePath = "/kozi.png";
  }
  // Function to generate a random Tournakis position
  const generateRandomPosition = () => {
    return {
      x: Math.floor(Math.random() * 80) + 10, // 10%-90% range (as percentage)
      y: Math.floor(Math.random() * 80) + 10, // 10%-90% range (as percentage)
    };
  };

  // Function to start the game
  const startGame = () => {
    setGameStarted(true);
    setScore(0);
    setCurrentLandscape(0);
    setIsFound(false);

    // Generate initial position
    const newPosition = generateRandomPosition();
    console.log("Initial position:", newPosition);
    setTournakisPosition(newPosition);
  };

  // Function to move to next landscape
  const nextLandscape = () => {
    if (currentLandscape < landscapes.length - 1) {
      const newLandscape = currentLandscape + 1;
      setCurrentLandscape(newLandscape);
      setIsFound(false);

      // Generate new position for the next landscape
      const newPosition = generateRandomPosition();
      console.log(
        `New position for landscape ${newLandscape + 1}:`,
        newPosition
      );
      setTournakisPosition(newPosition);
    } else {
      alert(
        `Congratulations! You found Tournakis in all ${landscapes.length} landscapes!`
      );
      setGameStarted(false);

      const music = document.getElementById("bg-music");
      if (music) {
        music.volume = 0.4; // Optional: lower volume
        music.play().catch((e) => {
          console.log("Autoplay blocked:", e);
        });
      }
    }
  };

  // Handle image loading
  useEffect(() => {
    if (landscapes.length > 0 && gameStarted) {
      setImageLoaded(false);

      const img = new Image();
      img.onload = () => {
        setImageLoaded(true);
      };
      img.src = landscapes[currentLandscape];
    }
  }, [currentLandscape, landscapes, gameStarted]);

  useEffect(() => {
    if (isFound) {
      const timeout = setTimeout(() => {
        nextLandscape();
      }, 1000); // 1000ms = 1 second

      return () => clearTimeout(timeout); // Cleanup if unmounted or isFound changes
    }
  }, [isFound]);

  <audio id="bg-music" src="/tournakis.mp3" loop autoPlay />;

  // Handle click event on the landscape
  const handleClick = (event) => {
    if (isFound || !imageLoaded) return;

    const rect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Convert click coordinates to percentage of image dimensions
    const clickXPercent = (x / rect.width) * 100;
    const clickYPercent = (y / rect.height) * 100;

    console.log("Click position:", { clickXPercent, clickYPercent });
    console.log("Tournakis position:", tournakisPosition);

    // Calculate distance between click and Tournakis
    const distance = Math.sqrt(
      Math.pow(clickXPercent - tournakisPosition.x, 2) +
        Math.pow(clickYPercent - tournakisPosition.y, 2)
    );

    // Detection radius (8% of the image width)
    const hitRadius = 8;
    console.log("Distance:", distance, "Hit radius:", hitRadius);

    if (distance < hitRadius) {
      console.log("Found Tournakis!");
      setIsFound(true);
      setScore((prevScore) => prevScore + 1);
    }
  };

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-800 relative overflow-hidden">
      {/* Animated background elements */}
      <audio id="bg-music" src="/tournakis.mp3" loop />
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-32 h-32 bg-yellow-300 rounded-full animate-pulse"></div>
        <div className="absolute top-32 right-20 w-24 h-24 bg-cyan-300 rounded-full animate-bounce"></div>
        <div className="absolute bottom-20 left-32 w-40 h-40 bg-emerald-300 rounded-full animate-pulse delay-1000"></div>
        <div className="absolute bottom-32 right-10 w-28 h-28 bg-orange-300 rounded-full animate-bounce delay-500"></div>
      </div>

      {!gameStarted ? (
        <div className="text-center z-10 max-w-2xl mx-auto px-8">
          {/* Main Title */}
          <div className="mb-12">
            <h1 className="text-7xl font-black mb-4 bg-gradient-to-r from-yellow-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent tracking-tight">
              Find Tournakis!
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 mx-auto rounded-full"></div>
          </div>

          {/* Game Description */}
          <div className="mb-12 space-y-4">
            <p className="text-2xl text-white/90 font-light leading-relaxed">
              Ξεκίνα μια επική περιπέτεια μέσα από εντυπωσιακά τοπία
            </p>
            <p className="text-lg text-white/70 font-light">
              Μπορείς να εντοπίσεις τον Τουρνάκη σε κάθε όμορφη σκηνή; Δοκίμασε
              τις παρατηρητικές σου ικανότητες!
            </p>
          </div>

          {/* Game Features */}
          <div className="mb-12 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl mb-2">🎯</div>
              <h3 className="text-white font-semibold mb-2">Αετομάτης</h3>
              <p className="text-white/70 text-sm">
                Τέσταρε τις παρατηρητικές σου ικανότητες
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl mb-2">🏞️</div>
              <h3 className="text-white font-semibold mb-2">Όμορφες Σκηνές</h3>
              <p className="text-white/70 text-sm">
                Εξερεύνησε εντυπωσιακά τοπία
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl mb-2">🏆</div>
              <h3 className="text-white font-semibold mb-2">Achievements</h3>
              <p className="text-white/70 text-sm">
                Ολοκλήρωσε και τα {landscapes.length} levels
              </p>
            </div>
          </div>

          {/* Start Button */}
          <div className="relative group">
            <button
              onClick={startGame}
              className="relative bg-gradient-to-r from-emerald-500 via-cyan-500 to-blue-500 hover:from-emerald-400 hover:via-cyan-400 hover:to-blue-400 text-white font-bold text-xl px-12 py-5 rounded-2xl shadow-2xl transform transition-all duration-300 hover:scale-105 hover:shadow-cyan-500/25 active:scale-95 border-2 border-white/20"
            >
              <span className="relative z-10 flex items-center justify-center space-x-3">
                <span>🔍</span>
                <span>Start Adventure</span>
                <span>✨</span>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>

            {/* Button glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-cyan-500 to-blue-500 rounded-2xl blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-300 -z-10"></div>
          </div>

          {/* Instructions */}
          <div className="mt-8 text-white/60 text-sm font-light">
            <p>
              💡 Tip: Παρατήρησε προσεκτικά κάθε εικόνα και κλίκαρε τον Τουρνάκη
              μόλις τον βρεις!
            </p>
          </div>
        </div>
      ) : (
        <>
          <p className="mb-4 text-lg font-semibold text-white z-10">
            Score: {score} | Level: {currentLandscape + 1}/{landscapes.length}
          </p>

          <div className="w-full flex justify-center">
            <div className="relative w-screen h-screen overflow-auto bg-black hide-scrollbar">
              {imageLoaded ? (
                <div
                  className="relative cursor-pointer"
                  onClick={handleClick}
                  style={{ position: "relative" }}
                >
                  {/* Landscape Image */}
                  <img
                    src={landscapes[currentLandscape]}
                    alt={`Landscape ${currentLandscape + 1}`}
                    className="w-full h-full object-cover"
                    style={{ display: "block" }}
                  />

                  {/* Static positioned Tournakis - CSS approach */}
                  {!isFound && (
                    <div
                      style={{
                        position: "absolute",
                        left: `${tournakisPosition.x}%`,
                        top: `${tournakisPosition.y}%`,
                        width: "30px",
                        height: "30px",
                        marginLeft: "-15px",
                        marginTop: "-15px",
                        zIndex: 20,
                        pointerEvents: "none",
                      }}
                    >
                      <img
                        src={tournakisImagePath}
                        alt="Tournakis"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  )}

                  {/* Debug position indicator */}
                </div>
              ) : (
                <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                  <p>Loading landscape...</p>
                </div>
              )}

              {isFound && (
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                  <h2 className="text-xl font-bold text-green-400 mb-2">
                    Βρήκες τον Τουρνάκη!
                  </h2>
                </div>
              )}
            </div>
          </div>

          <p className="mt-4 text-gray-600 italic z-10">
            Κλίκαρε τον Τουρνάκη μόλις τον βρεις!
          </p>
        </>
      )}
    </div>
  );
}
